import React from "react";
import { Badge } from "react-bootstrap";
import {
  FaBook, FaGlobe
} from "react-icons/fa";
import GenericCrudPage from '../components/GenericCrudPage'; 

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Validation for Semester form
const validateSemesterForm = (form) => {
  const errors = {};
  if (!form.exName.trim()) errors.exName = "Semester Name is required";
  if (form.exName.length > 100) errors.exName = "Semester Name must be less than 100 characters";
  return errors;
};

// Configuration for Semester CRUD operations
const semesterConfig = {
  baseUrl: BASE_URL,
  endpoints: {
    fetch: '/master/getSemster',
    save: '/master/saveSemster',
    update: '/master/updateSemster',
    delete: '/master/deleteSemster'
  },
  validateForm: validateSemesterForm,
  initialFormState: {
    exName: "", exLocalLangName: "", exIsActive: 1, user: ""
  },
  entityName: 'Semester'
};

// Form fields configuration
const formFields = [
  { name: "exName", label: "Semester Name", icon: FaBook, required: true },
  { name: "exLocalLangName", label: "Local Language Name", icon: FaGlobe },
];

// Table columns configuration
const tableColumns = [
  {
    key: 'exName',
    label: 'Semester Name',
    sortable: true,
    render: (semester) => (
      <div className="fw-bold">{semester.exName}</div>
    )
  },
  { key: 'exLocalLangName', label: 'Local Language', sortable: true, render: (semester) => semester.exLocalLangName || '-' }
];

// CSV export headers
const csvHeaders = [
  { key: 'exName', label: 'Semester Name' },
  { key: 'exLocalLangName', label: 'Local Language Name' },
  { key: 'exIsActive', label: 'Status', formatter: (value) => (value ? "Active" : "Inactive") }
];

// Transform form data to API payload
// The userId is passed from GenericCrudPage
const transformPayload = (form, editId, userId) => ({
  exName: form.exName.trim(),
  exLocalLangName: form.exLocalLangName.trim(),
  exIsActive: form.exIsActive,
  user: userId, // Ensure user is passed
  ...(editId && { id: editId })
});

// Transform API data to form
const transformToForm = (semester) => ({
  exName: semester.exName || "",
  exLocalLangName: semester.exLocalLangName || "",
  exIsActive: semester.exIsActive,
  user: semester.user || "", // User ID from fetched data
});

// Get view modal fields
const getViewFields = (semester) => {
  if (!semester) return [];
  return [
    { label: "Semester Name", value: semester.exName, icon: FaBook },
    { label: "Local Language Name", value: semester.exLocalLangName, icon: FaGlobe },
  ];
};

export default function SemesterPage() {
  return (
    <GenericCrudPage
      title="Semesters" // This will be the header text for the page
      config={semesterConfig}
      formFields={formFields}
      tableColumns={tableColumns}
      emptyIcon={FaBook}
      searchPlaceholder="Search by name, local language..."
      csvHeaders={csvHeaders}
      csvFilename="semesters_export.csv"
      transformPayload={transformPayload}
      transformToForm={transformToForm}
      getViewFields={getViewFields}
    />
  );
}